import {Modal, Button, Form, Row, FormGroup, FormLabel, Col, Spinner} from 'react-bootstrap'
import {Field, Formik} from 'formik'
import {useIntl} from 'react-intl'
import {MyOrder} from '../../models/myOrders'
import {requestModifyOrder} from '../../requests/requests'
import {OrderEdit} from '../../models/orderEdit'
import {ToastifyCaller, ToastifyType} from '../Toastify'
import {useQueryValidateOrders} from '../../hooks/useQueryValidateOrders'

export const UpdateExternalRefModal = ({
  show,
  onHide,
  refetch,
  changing,
  setChanging,
}: {
  show: MyOrder | undefined
  onHide: any
  refetch: any
  changing: boolean
  setChanging: any
}) => {
  const intl = useIntl()
  const {refetchValidateOrders} = useQueryValidateOrders(new Date())

  return (
    <Modal
      show={show ? true : false}
      onHide={onHide}
      dialogClassName='modal-dialog modal-dialog-centered modal-lg'
    >
      <Modal.Header closeButton>
        <h2 className='text-black'>
          {intl.formatMessage({id: 'UPDATE_EXTERNAL_REF_MODAL.TITLE'})}
        </h2>
      </Modal.Header>
      <Modal.Body className='modal-body py-lg-10 px-lg-20'>
        <Formik
          initialValues={{
            customerExternalReference: show ? show.detail.customerExternalReference : '',
          }}
          onSubmit={async ({customerExternalReference}) => {
            if (show && customerExternalReference) {
              show.detail.customerExternalReference = customerExternalReference
              const orderEditObj = {
                guidId: show.guidId,
                clientId: show.clientId,
                expeditionDate: show.expeditionDate,
                detail: show.detail,
                lines: show.lines,
              } as OrderEdit
              const response = await requestModifyOrder(orderEditObj)
              const allOK = response.status >= 200 && response.status
              if (allOK) {
                onHide()
                await refetch()
                await refetchValidateOrders()
                ToastifyCaller(
                  intl.formatMessage({id: 'UPDATE_EXTERNAL_REF_MODAL.UPDATE_OK'}),
                  ToastifyType.SUCCESS
                )
              }
            }
          }}
        >
          {({handleSubmit, handleChange}) => (
            <Form onSubmit={(e) => {
              setChanging(true)
              handleSubmit(e);
            }}>
              <Row className='mb-12'>
                <Col xs='12'>
                  <FormGroup>
                    <Field
                      type='text'
                      id='customerExternalReference'
                      name='customerExternalReference'
                      className='form-control'
                      onChange={handleChange}
                      maxlength={20}
                    />
                    <FormLabel htmlFor='customerExternalReference' />
                  </FormGroup>
                </Col>
              </Row>

              <div className='d-flex justify-content-end'>
                <Button
                  type='reset'
                  className='btn btn-secondary btm-sm mt-8  me-4'
                  onClick={onHide}
                >
                  {intl.formatMessage({id: 'BUTTON.CANCEL'})}
                </Button>
                <Button variant='primary' type='submit' className={`btn btn-primary btm-sm mt-8`} disabled={changing}>
                  {intl.formatMessage({id: 'BUTTON.SAVE'})}
                  {changing && <Spinner animation='border' className='mx-3' size='sm'/>}
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  )
}
